import { removeAuth } from "@/store/features/auth.slice";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import i18next from "i18next";
import { toast } from "react-toastify";

export const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_APP_API,
  credentials: "include",
  // KPI drilldowns can trigger large historical batch queries that legitimately
  // take longer than the default 30s, especially for margin tables.
  timeout: 120000,
  prepareHeaders: (headers, api) => {
    // const state = api.getState() as RootState;
    // const { auth } = state.auth;

    // // If we have a token set in state, let's assume that we should be passing it.
    // if (auth) {
    //   headers.set("authorization", `Bearer ${auth.token}`);
    // }

    return headers;
  },
});

export const baseRestQueryResult: any = async (args: any, api: any, extraOptions: any) => {
  let result
  try {
    result = await baseQuery(args, api, extraOptions)
    // Intercept HTTP 401 responses
    if (result.error && result.error.status === 401) {
      api.dispatch(removeAuth())
      window.location.href = `/login`
    }
    return result
  } catch (e: any) {
    console.log(e)
  }
}

export const showNotification = (method: string, type: string, message: string = "") => {
  let content = ""
  switch(method) {
    case 'POST': 
      content = type === "error" ? message : i18next.t("notification.add_successfully")
      break;
    case "PUT":
      content = type === "error" ? message : i18next.t("notification.edit_successfully")
      break
    default:
      content = type === "error" ? message : i18next.t("notification.delete_successfully")
      break
    
  }
  type === "success" ? toast.success(content) : toast.error(content)
}
